import styled from 'styled-components'
import { UnstyledList } from '@velasca/ui/unstyled-list'

export const List = styled(UnstyledList)`
  display: flex;
  flex-direction: column;
  gap: 1.8rem;
  padding: 1.8rem;
`
